import { type AnimalForSubState, SUB_STATE_LABEL, producingSubState } from "../producingSubState";

type Props = {
  animal: AnimalForSubState;
};

// Sprint 3 (2026-05-17): badge visual para sub-estado de vacas en producción.
// Usa colores del design system (no hex hardcoded). Decisión vía UI, no
// sub-cuenta contable (decisions-log.md 2026-05-17).
export function ProducingSubStateBadge({ animal }: Props) {
  const state = producingSubState(animal);
  if (!state) return null;

  const styles =
    state === "lactando"
      ? "bg-app-emerald/10 text-app-emerald"
      : state === "pronta"
        ? "bg-amber-100 text-amber-800"
        : "bg-app-surface-2 text-app-ink-2";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 font-medium text-[11px] ${styles}`}
      title={`Sub-estado operativo: ${SUB_STATE_LABEL[state]}`}
    >
      {SUB_STATE_LABEL[state]}
    </span>
  );
}
